import { type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { useAcceptedMoves } from '../../lib/accepted-move';
import { useMovePage } from '../../lib/move-page';

// "Put everything back" (#6772, prototype toolbarHTML `:2578`, moveReset `:2699`): a text
// button, shown to an admin once something this viewer moved since the page loaded is off the
// machine it started on. Mounted by the Machines panel on its OWN gate, in every view (review
// round 4): the List view's narrow cards move work too, and have no card-size toolbar. It runs through the server's limits, one move per
// machine pair, one part at a time (`lib/put-back.ts`): a refused part stops the run and the
// next press resumes from it. `aria-disabled` while a run is going and while the page guard is
// locked (each part also checks its own machine before it is sent).

export function PutBackButton(props: { readonly canWrite: boolean }): JSX.Element {
  const a = useAcceptedMoves();
  const page = useMovePage();
  const why = (): string | null =>
    (page?.locked() ?? 0) > 0 ? t('fleet.machines.ctl_locked', { n: page?.locked() ?? 0 }) : null;
  const off = (): boolean => a?.putting() === true || why() !== null;
  return (
    <Show when={props.canWrite && a?.movedAway() === true}>
      <p class="move-put-back__row">
        <button
          type="button"
          class="move-put-back"
          aria-disabled={off() ? 'true' : undefined}
          title={why() ?? t('fleet.move.put_back_title')}
          onClick={() => {
            if (why() !== null) page?.announce(t('fleet.machines.ctl_model_locked'));
            else if (!off()) void a?.putBack();
          }}
        >
          {t('fleet.move.put_back')}
        </button>
      </p>
    </Show>
  );
}
